// @ts-nocheck
// 导入 抽取的 请求对象
import ajaxRequest from '@/utils/request';
import { getToken } from '../utils/token';

const reFix = 'newsadmin';

// 获取客服人员
export function getCustSerApi(params) {
  return ajaxRequest({
    url: reFix + '/CustSer',
    params,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 修改客服人员
export function setCustSerApi(data) {
  return ajaxRequest({
    url: reFix + '/CustSer',
    method: 'PUT',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 新增客服人员
export function addCustSerApi(data) {
  return ajaxRequest({
    url: reFix + '/CustSer',
    method: 'POST',
    data,
    headers: { 'Content-Type': 'application/json' },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 删除客服人员
export function deleteCustSerApi(custSerId) {
  let data = 'custSerId=' + custSerId;
  return ajaxRequest({
    url: reFix + '/CustSer',
    method: 'DELETE',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
